import React from "react";
// import "./StreamTabContent.less"; // 可选：如需自定义样式可创建此文件
import StreamsDataTable from "./result_stream_dataTable"; // 对应你迁移后的流股工艺数据表组件
import StreamsComponentTable from "./result_stream_component_table"; // 流股组分数据表组件（后续需迁移）

// 定义类型接口，提升代码健壮性
// interface StreamTabContentProps {
//   source: {
//     inputStreams: any[];
//     outStreams: any[];
//   };
//   materials: {
//     materials: any[] | Record<string, any>; // 根据实际数据结构调整
//   };
//   selectResultPage: string; // 选中的标签页："流股工艺数据" | "流股组分数据"
// }

const StreamTabContent = ({ source, materials, selectResultPage }) => {
  return (
    <div className="stream-tab-content-container">
      {/* 根据选中的标签页渲染对应表格 */}
      {selectResultPage === "流股工艺数据" ? (
        <StreamsDataTable source={source} />
      ) : (
        <StreamsComponentTable source={source} materials={materials.materials} />
      )}
    </div>
  );
};

export default StreamTabContent;